<template>
  <div class="leave">
    <van-nav-bar
      @click-left="clickBack"
      right-text="我要请假"
      @click-right="clickNavBarRight"
      left-arrow
    >
    </van-nav-bar>



    <!-- <van-nav-bar @click-right="onClickRight">
      <template #left>
        <div style="color: #333">请假审批状态</div>
      </template>
      <template #right>
        <div style="color: #646566">
          {{ selectText }}
          <van-icon name="arrow" color="#646566" />
        </div>
      </template>
    </van-nav-bar> -->



    <van-action-sheet
      v-model="show"
      :actions="actions"
      cancel-text="取消"
      @select="onSelect"
    />
    
    <div class="leave-list-wrap">
      <van-list
        v-model="loading"
        v-if="list.length > 0"
        class="leave-list"
        :immediate-check="false"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
      >
        <div
          class="leave-list-item"
          v-for="item in list"
          :key="item.id"
          @click="clickLeaveDetail(item)"
        >
          <div class="cause flex flex-b flex-vc">
            <span
              >{{ item.leaveType }}（共计{{
                renderTime(item.leaveTime)
              }}）</span
            >
            <!-- <span class="status">{{ item.leaveState }}</span> -->
            <van-tag plain type="success" v-if="item.leaveState == 1"
              >已通过</van-tag
            >
            <van-tag plain type="primary" v-if="item.leaveState == 0"
              >待审批</van-tag
            >
            <van-tag plain type="danger" v-if="item.leaveState == -1"
              >已驳回</van-tag
            >
            <van-tag plain type="danger" v-if="item.leaveState == -2"
              >已过期</van-tag
            >
            <van-tag plain type="danger" v-if="item.leaveState == -3"
              >已作废</van-tag
            >
          </div>
          <div class="date">
            <span>开始时间：</span
            ><span>{{ getDateYMD(item.leaveBeginTime) }}</span>
          </div>
          <div class="date">
            <span>结束时间：</span
            ><span>{{ getDateYMD(item.leaveEndTime) }}</span>
          </div>
          <div class="date flex flex-b">
            <div>
              <span>请假原因：</span
              ><span style="word-break: break-all">{{ item.remark }}</span>
            </div>

            <div
              class="flex flex-vc report"
              v-if="
                item.leaveState == 1 &&
                item.cancelLeaveState == 0 &&
                isDuringDate(item.leaveBeginTime, item.leaveEndTime)
              "
            >
              <van-icon name="notes-o" style="margin-right: 0.3rem" />
              销假
            </div>
          </div>
          <!-- <div class="note flex">
            <span>审 批 人：</span
            ><span class="flex-1"
              ><van-steps
                direction="vertical"
                :active="2"
                active-color="#1989fa"
              >
                <van-step v-for="v in item.leaveApprovalAudit">
                  <div>
                    <span style="margin-right: 0.5rem;">{{ v.auditName }}</span>
                    <van-tag
                      plain
                      type="success"
                      size="medium"
                      v-if="v.auditState == 1"
                      >已同意</van-tag
                    >
                    <van-tag
                      plain
                      type="primary"
                      size="medium"
                      v-if="v.auditState == 0"
                      >待审批</van-tag
                    >
                    <van-tag
                      plain
                      type="danger"
                      size="medium"
                      v-if="v.auditState == -1"
                      >已拒绝</van-tag
                    >
                  </div>
                  <div v-if="v.auditTime">
                    <span>时间</span>{{ v.auditTime }}
                  </div>
                  <div v-if="v.auditRemark">
                    <span>备注</span>{{ v.auditRemark }}
                  </div>
                </van-step>
              </van-steps></span
            >
          </div> -->
        </div>
      </van-list>

      <div class="" v-if="list.length <= 0">
        <van-empty description="暂无数据" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { compare, getDateYMD, timeFormart } from "@/utils";

export default {
  data() {
    return {
      list: [],
      // 审批状态选择弹窗
      show: false,
      // 请假状态集合
      actions: [
        {
          name: "待审批",
        },
        {
          name: "已通过",
        },
        {
          name: "已驳回",
        },
        {
          name: "已过期",
        },
        {
          name: '全部'
        }
      ],
      // 选中的状态
      selectText: "全部",
      totalPageNum: "",
      pageNum: 1,
      // 控制滚动
      loading: false,
      finished: false,
      error: false
    };
  },
  mounted() {
    // 获取请假列表
    Promise.all([
      this.getLeaveList(-11),
    ]).then((res) => {
      // 设置总页数和当前页数
      this.totalPageNum = res[0].totalPage
      this.pageNum = 1
      res.forEach((item) => {
        item.list &&
          item.list.forEach((v) => {
            // v.leaveState = this.getStatus(v.leaveState)
            this.list.push(v);
          });
      });
    });
  },

  methods: {
    getDateYMD,
    getStatus(state) {
      let map = {
        0: "待审批",
        1: "申请成功",
        "-1": "申请失败",
      };
      return map[state];
    },
    clickBack() {
      this.$router.go(-1);
    },
    clickNavBarRight() {
      this.$router.push("/teacherLeaveForm");
    },
    clickLeaveDetail(item) {
      this.$router.push({
        path: "/leavedetail",
        query: { id: item.id, type: "list", approvalId: item.approvalId },
      });
    },

    // 获取到请假列表
    async getLeaveList(state) {
      const { data, code } = await this.$https.getMyLeaveList({
        leaveState: state,
        userId: this.$store.state.userId,
        schoolId: this.$store.state.schoolId,
        pageSize: 10,
        pageNum: 1
      });
      if (code !== 200) {
        return false;
      }
      return Promise.resolve(data);
    },



    renderTime(StatusMinute) {
      var day = parseInt(StatusMinute / 60 / 24);
      var hour = parseInt((StatusMinute / 60) % 24);
      var min = parseInt(StatusMinute % 60);
      StatusMinute = "";
      if (day > 0) {
        StatusMinute = day + "天";
      }
      if (hour > 0) {
        StatusMinute += hour + "小时";
      }
      if (min > 0) {
        StatusMinute += parseFloat(min) + "分钟";
      }
      return `${StatusMinute}`;
    },
    isDuringDate(s, e) {
      if (moment().isAfter(s) && moment().isBefore(e)) {
        return true;
      }
      return false;
    },
    // renderTime(time) {
    //   const t = time / 60
    //   const ti = t > 24 ? t % 24 : t
    //   return ti
    // },


    // 分页相关内容
    async onLoad () {

      let obj = {
        待审批: 0,
        已通过: 1,
        已驳回: -1,
        已过期: -2,
        全部: -11
      };
      // console.log('进来了吗',this.pageNum , this.totalPageNum)
      // return 
      // 判断滚动加载
      if (this.pageNum == this.totalPageNum) {
        this.finished = true;
        this.loading = false
      } else if (this.loading && this.pageNum != this.totalPageNum) {
        
        this.finished = false
        let newList = await this.getApprovalList(obj[this.selectText],this.pageNum + 1)
        if (!newList) {
          this.error = true
          this.loading = false
          return 
        }
        this.list = [...this.list,...newList.list]
        this.pageNum = this.pageNum + 1
        this.totalPageNum = newList.totalPage
        this.loading = false
      }
    },

    onClickRight() {
      this.show = true
    },

    // 选择请假状态
    async onSelect (item) {
      this.error = false
      this.finished = false
      this.pageNum = 1
      let obj = {
        待审批: 0,
        已通过: 1,
        已驳回: -1,
        已过期: -2,
      }
      this.show = false
      // 获取请假列表
      let leaveList = await this.getApprovalList(obj[item.name],1)
      this.totalPageNum = leaveList.totalPage
      if (leaveList.list){ 
        this.list = leaveList.list
      }
      this.selectText = item.name
    },

    // 分页的查询方法
    async getApprovalList (state,pageNum) {
      console.log('进来了')
      const { data, code } = await this.$https.getMyLeaveList({
        leaveState: state,
        userId: this.$store.state.userId,
        schoolId: this.$store.state.schoolId,
        pageSize: 10,
        pageNum
      });
      if (code != 200) {
        return false
      }
      return data
    }




  },
};
</script>

<style lang="scss" scoped>
.leave-list-wrap {
  position: relative;
  .leave-list-title {
    padding: 1rem;
  }
  .leave-list {
    border-radius: 0.75rem;
    border-radius: 1.0625rem;
    margin: 1rem;
    box-shadow: 0rem 1rem 1rem rgba(69, 91, 99, 0.1);
    overflow: hidden;
    .leave-list-item {
      display: flex;
      flex-direction: column;
      padding: 0.75rem;

      background: #fff;
      font-size: 0.75rem;
      color: rgba(120, 132, 158, 1);
      border-bottom: 1px solid #f4f4f6;

      .cause {
        font-size: 1rem;
        font-weight: bold;
        color: #333;
        margin-bottom: 0.55rem;
        .status {
          color: #1989fa;
          font-size: 0.85rem;
        }
      }
      .date {
        margin-bottom: 0.55rem;
      }
    }
  }
}

.report {
  font-size: 1rem;
}
</style>
